import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import './i18n'; // Initialize i18n

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        html, body {
          font-size: 16px !important;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          overflow-x: hidden !important;
          max-width: 100vw !important;
          position: relative !important;
          height: auto !important;
        }
        * {
          box-sizing: border-box !important;
        }
        #root {
          overflow-x: hidden !important;
          max-width: 100vw !important;
          position: relative !important;
          height: auto !important;
        }
        .MuiContainer-root,
        .MuiPaper-root,
        .MuiAccordion-root,
        .MuiCard-root,
        .MuiTableContainer-root {
          max-width: 100% !important;
          overflow-x: hidden !important;
          box-sizing: border-box !important;
        }
        .MuiTable-root {
          max-width: 100% !important;
          table-layout: fixed !important;
        }
        .MuiAccordionDetails-root {
          overflow-x: hidden !important;
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
        .MuiTableCell-root {
          word-break: break-word !important;
          overflow: hidden !important;
        }
      `,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
); 